import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { FORMAT_ELEMENT_COMMAND } from "lexical";
import { useTheme } from "@mui/material/styles";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Icon } from "../../../../../Icon/index.js";
import { Box } from "../../../../../Box/index.js";
const formatTypeToBlockName = {
    left: 'По левому краю',
    center: 'По центру',
    right: 'По правому краю',
    justify: 'По ширине'
};
const getFormatIcon = (format, theme, activeFormat)=>{
    const getColor = (item, activeItem)=>item === activeItem ? 'original.brand.primary' : 'text.light.primary';
    switch(format){
        case 'left':
            return /*#__PURE__*/ jsx(Icon, {
                name: "text_left_outline",
                color: getColor('left', activeFormat),
                size: "20"
            });
        case 'center':
            return /*#__PURE__*/ jsx(Icon, {
                name: "text_center_outline",
                color: getColor('center', activeFormat),
                size: "20"
            });
        case 'right':
            return /*#__PURE__*/ jsx(Icon, {
                name: "text_right_outline",
                color: getColor('right', activeFormat),
                size: "20"
            });
        case 'justify':
            return /*#__PURE__*/ jsx(Icon, {
                name: "vkhrtek_justify_format",
                color: getColor('justify', activeFormat),
                size: "16"
            });
        default:
            return /*#__PURE__*/ jsx(Icon, {
                name: "text_left_outline",
                color: "text.light.primary",
                size: "20"
            });
    }
};
const useFormatElement = (editor, alignFormat)=>{
    const $ = c(12);
    const theme = useTheme();
    let t0;
    if ($[0] !== editor) {
        t0 = (format)=>()=>{
                editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, format);
            };
        $[0] = editor;
        $[1] = t0;
    } else t0 = $[1];
    const handleFormat = t0;
    let t1;
    if ($[2] !== alignFormat || $[3] !== handleFormat || $[4] !== theme) {
        t1 = Object.entries(formatTypeToBlockName).map((t2)=>{
            const [format_0, name] = t2;
            return /*#__PURE__*/ jsx(MenuItem, {
                onClick: handleFormat(format_0),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    gap: "8",
                    children: [
                        getFormatIcon(format_0, theme, alignFormat),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body3",
                            color: alignFormat === format_0 ? "original.brand.primary" : "text.light.primary",
                            children: name
                        })
                    ]
                })
            }, format_0);
        });
        $[2] = alignFormat;
        $[3] = handleFormat;
        $[4] = theme;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== alignFormat || $[7] !== theme) {
        t2 = getFormatIcon(alignFormat, theme);
        $[6] = alignFormat;
        $[7] = theme;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== t1 || $[10] !== t2) {
        t3 = [
            t1,
            t2
        ];
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
};
export { formatTypeToBlockName, getFormatIcon, useFormatElement };
